import React from "react";

type Props = {};

const Header = (props: Props) => {
  const [menuOpen, setMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header
      className="flex items-center justify-between p-4 bg-white shadow-md sticky top-0 z-50 backdrop-blur-sm border-b border-white/60"
      style={{ background: "rgba(93, 120, 89, 0.15)" }}
    >
      {/* Logo */}
      <img
        src={require("../../Assets/logo.png")}
        alt="Ecopack Logo"
        className="h-10 cursor-pointer"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      />

      {/* Desktop Navigation */}
      <nav className="hidden md:flex items-center space-x-8">
        <ul
          className="flex items-center space-x-8"
          style={{ color: "rgba(80, 80, 80, 1)" }}
        >
          <li>
            <a
              href="#about"
              className="text-gray-700 hover:text-green-800 transition-colors duration-200"
            >
              About Us
            </a>
          </li>
          <li>
            <a
              href="#services"
              className="text-gray-700 hover:text-green-800 transition-colors duration-200"
            >
              Services
            </a>
          </li>
          <li>
            <a
              href="#projects"
              className="text-gray-700 hover:text-green-800 transition-colors duration-200"
            >
              Projects
            </a>
          </li>
          <li>
            <a
              href="#team"
              className="text-gray-700 hover:text-green-800 transition-colors duration-200"
            >
              Team
            </a>
          </li>
        </ul>
      </nav>

      {/* Desktop Join Now Button */}
      <button
        className="hidden md:block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-medium transition-colors duration-200"
        style={{
          backgroundColor: "rgba(138, 154, 91, 1)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(120, 134, 80, 1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(138, 154, 91, 1)";
        }}
      >
        Join Now
      </button>

      {/* Mobile Menu Button */}
      <button
        className="md:hidden focus:outline-none z-50"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <svg
          className="w-6 h-6 text-gray-700"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          {menuOpen ? (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          ) : (
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          )}
        </svg>
      </button>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-opacity-50 z-40 md:hidden"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* Mobile Navigation Menu */}
      <nav
        className={`fixed top-0 right-0 h-full w-80 shadow-xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ backgroundColor: "white" }}
      >
        <div className="flex flex-col h-full">
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <img
              src={require("../../Assets/logo.png")}
              alt="Ecopack Logo"
              className="h-8"
            />
            <button
              onClick={() => setMenuOpen(false)}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              aria-label="Close menu"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Mobile Menu Items */}
          <ul
            className="flex-1 py-4"
            style={{ color: "rgba(80, 80, 80, 1)", backgroundColor: "white" }}
          >
            <li>
              <a
                href="#about"
                className="block px-6 py-4 text-gray-700 hover:bg-gray-50 hover:text-green-800 transition-colors duration-200 border-b border-gray-100"
                onClick={() => setMenuOpen(false)}
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="#services"
                className="block px-6 py-4 text-gray-700 hover:bg-gray-50 hover:text-green-800 transition-colors duration-200 border-b border-gray-100"
                onClick={() => setMenuOpen(false)}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#projects"
                className="block px-6 py-4 text-gray-700 hover:bg-gray-50 hover:text-green-800 transition-colors duration-200 border-b border-gray-100"
                onClick={() => setMenuOpen(false)}
              >
                Projects
              </a>
            </li>
            <li>
              <a
                href="#team"
                className="block px-6 py-4 text-gray-700 hover:bg-gray-50 hover:text-green-800 transition-colors duration-200 border-b border-gray-100"
                onClick={() => setMenuOpen(false)}
              >
                Team
              </a>
            </li>
          </ul>

          {/* Mobile Join Now Button */}
          <div
            className="p-6 border-t border-gray-200"
            style={{ backgroundColor: "white" }}
          >
            <button
              className="w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-medium transition-colors duration-200"
              style={{
                backgroundColor: "rgba(138, 154, 91, 1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(120, 134, 80, 1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "rgba(138, 154, 91, 1)";
              }}
              onClick={() => setMenuOpen(false)}
            >
              Join Now
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
